"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateGroupNodeIdAndAutoGenerated = exports.updateGroupDefaultExpansion = exports.removeNodeFromTree = exports.insertNodeInTree = exports.getVisibleRowsLookup = exports.getNodePathInTree = exports.getGroupRowIdFromPath = exports.createUpdatedGroupsManager = exports.checkGroupChildrenExpansion = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _xDataGrid = require("@mui/x-data-grid");
var getGroupRowIdFromPath = function(path) {
    var pathStr = path.map(function(groupingCriteria) {
        return "".concat(groupingCriteria.field, "/").concat(groupingCriteria.key);
    }).join('-');
    return "auto-generated-row-".concat(pathStr);
};
exports.getGroupRowIdFromPath = getGroupRowIdFromPath;
var getNodePathInTree = function(param) {
    var id = param.id, tree = param.tree;
    var path = [];
    var node = tree[id];
    while(node.id !== _xDataGrid.GRID_ROOT_GROUP_ID){
        path.push({
            field: node.type === 'leaf' ? null : node.groupingField,
            key: node.groupingKey
        });
        node = tree[node.parent];
    }
    path.reverse();
    return path;
};
exports.getNodePathInTree = getNodePathInTree;
var checkGroupChildrenExpansion = function(node, defaultGroupingExpansionDepth, isGroupExpandedByDefault) {
    var childrenExpanded;
    if (node.id === _xDataGrid.GRID_ROOT_GROUP_ID) {
        childrenExpanded = true;
    } else if (isGroupExpandedByDefault) {
        childrenExpanded = isGroupExpandedByDefault(node);
    } else {
        childrenExpanded = defaultGroupingExpansionDepth === -1 || defaultGroupingExpansionDepth > node.depth;
    }
    return childrenExpanded;
};
exports.checkGroupChildrenExpansion = checkGroupChildrenExpansion;
var updateGroupDefaultExpansion = function(node, defaultGroupingExpansionDepth, isGroupExpandedByDefault) {
    var childrenExpanded = checkGroupChildrenExpansion(node, defaultGroupingExpansionDepth, isGroupExpandedByDefault);
    node.childrenExpanded = childrenExpanded;
    return node;
};
/**
 * Insert a node in the tree
 */ exports.updateGroupDefaultExpansion = updateGroupDefaultExpansion;
var insertNodeInTree = function(node, tree, treeDepths, previousTree) {
    // 1. Insert node in the tree.
    tree[node.id] = node;
    var _treeDepths_node_depth;
    // 2. Increment the `treeDepths` object for the node's depth.
    treeDepths[node.depth] = ((_treeDepths_node_depth = treeDepths[node.depth]) !== null && _treeDepths_node_depth !== void 0 ? _treeDepths_node_depth : 0) + 1;
    // 3. Register the new node in its parent.
    var parentNode = tree[node.parent];
    if (node.type === 'group' || node.type === 'leaf') {
        var _parentNode_childrenFromPath;
        var _node_groupingField;
        // For groups and leaves,
        // Register the node from its parents `children` and `childrenFromPath` properties.
        var groupingFieldName = (_node_groupingField = node.groupingField) !== null && _node_groupingField !== void 0 ? _node_groupingField : '__no_field__';
        var _node_groupingKey;
        var groupingKeyName = (_node_groupingKey = node.groupingKey) !== null && _node_groupingKey !== void 0 ? _node_groupingKey : '__no_key__';
        var groupingField = (_parentNode_childrenFromPath = parentNode.childrenFromPath) === null || _parentNode_childrenFromPath === void 0 ? void 0 : _parentNode_childrenFromPath[groupingFieldName];
        if (previousTree !== null && previousTree[parentNode.id] === tree[parentNode.id]) {
            parentNode.children = _to_consumable_array(parentNode.children).concat([
                node.id
            ]);
        } else {
            parentNode.children.push(node.id);
        }
        if (groupingField == null) {
            parentNode.childrenFromPath[groupingFieldName] = _define_property({}, groupingKeyName.toString(), node.id);
        } else {
            groupingField[groupingKeyName.toString()] = node.id;
        }
    } else if (node.type === 'footer') {
        // For footers,
        // Register the node from its parent `footerId` property.
        parentNode.footerId = node.id;
    }
};
/**
 * Removes a node from the tree
 */ exports.insertNodeInTree = insertNodeInTree;
var removeNodeFromTree = function(param) {
    var node = param.node, tree = param.tree, treeDepths = param.treeDepths;
    // 1. Remove node from the tree.
    delete tree[node.id];
    // 2. Decrement the `treeDepths` object for the node's depth.
    var nodeDepth = node.depth;
    var currentNodeCount = treeDepths[nodeDepth];
    if (currentNodeCount === 1) {
        delete treeDepths[nodeDepth];
    } else {
        treeDepths[nodeDepth] = currentNodeCount - 1;
    }
    // 3. Unregister the new node in its parent.
    var parentNode = tree[node.parent];
    // For footers,
    // Unregister the node from its parent `footerId` property.
    if (node.type === 'footer') {
        tree[parentNode.id] = (0, _extends2.default)({}, parentNode, {
            footerId: null
        });
    } else {
        var _node_groupingField;
        var groupingField = (_node_groupingField = node.groupingField) !== null && _node_groupingField !== void 0 ? _node_groupingField : '__no_field__';
        var _node_groupingKey;
        var groupingKey = (_node_groupingKey = node.groupingKey) !== null && _node_groupingKey !== void 0 ? _node_groupingKey : '__no_key__';
        // TODO rows v6: Can we avoid this linear complexity ?
        var children = parentNode.children.filter(function(childId) {
            return childId !== node.id;
        });
        var childrenFromPath = parentNode.childrenFromPath;
        delete childrenFromPath[groupingField][groupingKey.toString()];
        tree[parentNode.id] = (0, _extends2.default)({}, parentNode, {
            children: children,
            childrenFromPath: childrenFromPath
        });
    }
};
/**
 * Updates the `id` and `isAutoGenerated` properties of a group node.
 */ exports.removeNodeFromTree = removeNodeFromTree;
var updateGroupNodeIdAndAutoGenerated = function(param) {
    var node = param.node, updatedNode = param.updatedNode, previousTree = param.previousTree, tree = param.tree, treeDepths = param.treeDepths;
    // 1. Set the new parent for all children from the old group
    node.children.forEach(function(childId) {
        tree[childId] = (0, _extends2.default)({}, tree[childId], {
            parent: updatedNode.id
        });
    });
    // 2. Remove the old group from the tree
    removeNodeFromTree({
        node: node,
        tree: tree,
        treeDepths: treeDepths
    });
    // 3. Add the new group in the tree
    var groupNode = (0, _extends2.default)({}, node, updatedNode);
    insertNodeInTree(groupNode, tree, treeDepths, previousTree);
};
exports.updateGroupNodeIdAndAutoGenerated = updateGroupNodeIdAndAutoGenerated;
var createUpdatedGroupsManager = function() {
    return {
        value: {},
        addAction: function(groupId, action) {
            if (!this.value[groupId]) {
                this.value[groupId] = {};
            }
            this.value[groupId][action] = true;
        }
    };
};
exports.createUpdatedGroupsManager = createUpdatedGroupsManager;
var getVisibleRowsLookup = function(param) {
    var tree = param.tree, filteredRowsLookup = param.filteredRowsLookup;
    if (!filteredRowsLookup) {
        return {};
    }
    var visibleRowsLookup = {};
    var handleTreeNode = function(node, areAncestorsExpanded) {
        var isPassingFiltering = filteredRowsLookup[node.id] !== false;
        if (node.type === 'group') {
            node.children.forEach(function(childId) {
                var childNode = tree[childId];
                handleTreeNode(childNode, areAncestorsExpanded && !!node.childrenExpanded);
            });
        }
        visibleRowsLookup[node.id] = isPassingFiltering && areAncestorsExpanded;
        // TODO rows v6: Should we keep storing the visibility status of footer independently or rely on the group visibility in the selector ?
        if (node.type === 'group' && node.footerId != null) {
            visibleRowsLookup[node.footerId] = isPassingFiltering && areAncestorsExpanded && !!node.childrenExpanded;
        }
    };
    var nodes = Object.values(tree);
    for(var i = 0; i < nodes.length; i += 1){
        var node = nodes[i];
        if (node.depth === 0) {
            handleTreeNode(node, true);
        }
    }
    return visibleRowsLookup;
};
exports.getVisibleRowsLookup = getVisibleRowsLookup;
